import Layout from '@layout/Index'

export const adminInboxMessage = [
  {
    path: '/admin-inbox-message',
    component: Layout,
    children: [
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "admin-inbox-message-table" */ './pages/AdminInboxMessageTable.vue'),
        meta: {
          title: '消息通知',
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/admin-inbox-message/admin-inbox-message.route.js